"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import RichText from "./webflow_modules/Basic/components/RichText";

export function RegionalPageRichText({ copyTopRichText = "" }) {
  return (
    <Block tag={"div"}>
      <Block className={"regional-page-rt-container"} tag={"div"}>
        <RichText className={"text-rich-text"} tag={"div"}>
          {copyTopRichText}
        </RichText>
      </Block>
    </Block>
  );
}
